import React from 'react';
import { Alert } from 'reactstrap';

const Success = (props: { [label: string]: any, content: any }) => {
    return (
        <div>
            <Alert style={{ borderRadius: '15px', border: 'none', background: 'none' }}>
                <p style={{ margin: 0, textAlign: "center", color: '#565e81' }}>
                    {props.content}
                </p>
            </Alert>
        </div>
    );
};

export default Success;



// WEBPACK FOOTER //
// ./src/components/alerts/Success.tsx